import Vue from 'vue'
import Vuex from 'vuex'
import staticData from '@api/staticData'

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        isLogged: false,
        user: null,

        listaEstados: [],
        optionsHistoricoCliente: {
            search: "",
        },
        optionsCliente: {
            itemsPerPage: 25,
            search: "",
        },
        optionsOrcamento: {},
        optionsPedido: {},
        optionsCrm: {},
        optionsProduto: {
            itemsPerPage: 25,
            search: "",
            onlyQuantidade: true,
        },
        optionsRelatorioPedido: {},
        optionsDepositoPedido: {},
        optionsAgendaEntrega: {},
        optionsAssistencia: {},
        optionsRelatorioProduto: {},
        optionsRelatorioAniversario: {
            itemsPerPage: -1,
            aniversarioInicio: new Date().toISOString().substr(0, 10),
        },
        optionsRelatorioOrcamento: {},
        optionsRelatorioEstoque: {
            itemsPerPage: 25,
            withEstoque: true,
            columns: [
                'produto.id',
                'produto.nome',
                'produto.referencia',
                'entidade.nome as fornecedor_nome',
                'categoria.nome as categoria_nome',
                'quantidade',
            ],
        },
        optionsRelatorioVeiculo: {
            itemsPerPage: 25,
        },
        optionsRelatorioAssistencia: {
            itemsPerPage: 25,
        },
        optionsRelatorioEntrega: {
            itemsPerPage: 25,
        },
        optionsRelatorioTerceirizado: {
            itemsPerPage: 25,
        },
        optionsMovimentacaoEstoque: {},
        optionsRelatorioAutorizacao: {
            itemsPerPage: 25,
        },
        formXml: null,
        listaProdutoXml: [],
        snackbar: null,
    },
    getters: {

    },
    mutations: {
        resetState: (state) => {
            Object.assign(state, {
                isLogged: false,
                user: null,

                listaEstados: [],
                optionsHistoricoCliente: {
                    search: "",
                },
                optionsCliente: {
                    itemsPerPage: 25,
                    search: "",
                },
                optionsOrcamento: {},
                optionsPedido: {},
                optionsCrm: {},
                optionsProduto: {
                    itemsPerPage: 25,
                    search: "",
                    onlyQuantidade: true,
                },
                optionsRelatorioPedido: {},
                optionsDepositoPedido: {},
                optionsAgendaEntrega: {},
                optionsAssistencia: {},
                optionsRelatorioProduto: {},
                optionsRelatorioAniversario: {
                    itemsPerPage: -1,
                    aniversarioInicio: new Date().toISOString().substr(0, 10),
                },
                optionsRelatorioOrcamento: {},
                optionsRelatorioEstoque: {
                    itemsPerPage: 25,
                    withEstoque: true,
                    columns: [
                        'produto.id',
                        'produto.nome',
                        'produto.referencia',
                        'entidade.nome as fornecedor_nome',
                        'categoria.nome as categoria_nome',
                        'quantidade',
                    ],
                },
                optionsRelatorioVeiculo: {
                    itemsPerPage: 25,
                },
                optionsRelatorioAssistencia: {
                    itemsPerPage: 25,
                },
                optionsRelatorioEntrega: {
                    itemsPerPage: 25,
                },
                optionsRelatorioTerceirizado: {
                    itemsPerPage: 25,
                },
                optionsRelatorioAutorizacao: {
                    itemsPerPage: 25,
                },
                optionsRelatorioMovimentacaoProduto: {
                    itemsPerPage: 25,
                },
                optionsMovimentacaoEstoque: {
                    itemsPerPage: 25,
                },
                formXml: null,
                listaProdutoXml: [],
                snackbar: null,
            });
        },
        isLogged(state, payload) {
            state.isLogged = payload
        },
        setUser(state, payload) {
            state.user = payload
        },
        setListaEstados(state, payload) {
            state.listaEstados = payload
        },
        setOptionsHistoricoCliente(state, payload) {
            state.optionsHistoricoCliente.search = payload
        },
        setOptionsCliente(state, payload) {
            state.optionsCliente = payload
        },
        setOptionsOrcamento(state, payload) {
            state.optionsOrcamento = payload
        },
        setOptionsPedido(state, payload) {
            state.optionsPedido = payload
        },
        setOptionsCrm(state, payload) {
            state.optionsCrm = payload
        },
        setOptionsProduto(state, payload) {
            state.optionsProduto = payload
        },
        setOptionsRelatorioPedido(state, payload) {
            state.optionsRelatorioPedido = payload
        },
        setOptionsRelatorioAutorizacao(state, payload) {
            state.optionsRelatorioAutorizacao = payload
        },
        setOptionsDepositoPedido(state, payload) {
            state.optionsDepositoPedido = payload
        },
        setOptionsAgendaEntrega(state, payload) {
            state.optionsAgendaEntrega = payload
        },
        setOptionsAssistencia(state, payload) {
            state.optionsAssistencia = payload
        },
        setOptionsRelatorioProduto(state, payload) {
            state.optionsRelatorioProduto = payload
        },
        setOptionsRelatorioAniversario(state, payload) {
            state.optionsRelatorioAniversario = payload
        },
        setOptionsRelatorioOrcamento(state, payload) {
            state.optionsRelatorioOrcamento = payload
        },
        setOptionsRelatorioEstoque(state, options) {
            state.optionsRelatorioEstoque = options;
        },
        setOptionsRelatorioVeiculo(state, options) {
            state.optionsRelatorioVeiculo = options;
        },
        setOptionsRelatorioAssistencia(state, payload) {
            state.optionsRelatorioAssistencia = payload
        },
        setOptionsRelatorioEntrega(state, payload) {
            state.optionsRelatorioEntrega = payload
        },
        setOptionsRelatorioTerceirizado(state, payload) {
            state.optionsRelatorioTerceirizado = payload
        },
        setOptionsRelatorioMovimentacaoEstoque(state, payload) {
            state.optionsMovimentacaoEstoque = payload
        },
        setOptionsRelatorioOrcamento(state, payload) {
            state.optionsRelatorioOrcamento = payload
        },
        setOptionsRelatorioSeparacao(state, options) {
            state.optionsRelatorioSeparacao = options;
        },
        setFormXml(state, payload) {
            state.formXml = payload
        },
        setListaProdutoXml(state, payload) {
            state.listaProdutoXml = payload
        },
        setSnackbar(state, payload) {
            state.snackbar = {
                show: true,
                text: payload.text,
                color: payload.color || 'info',
                timeout: payload.timeout || 5000
            }
        },
    },
    actions: {
        async loadStaticData({ commit }) {
            const listaStaticData = await staticData.getAll()
            commit('setListaEstados', listaStaticData.data.estados)
        },
        showMessage({ commit }, payload) {
            commit('setSnackbar', payload)
        }
    },
})

export default store
